export default __webpack_public_path__ + "static/gantmodern-medium-88d9d7cad657ffc9b1705b8ad12b11ce.woff";